interface MetaEvent {
    eventID: string;
    test_event_code?: string; // The '?' means it might not exist
}

export const usePayment = () => {
    const config = useRuntimeConfig();
    const localePath = useLocalePath();
    const localeStore = useLanguageStore();
    const isProcessing = ref(false);
    const paymentError = ref<string | null>(null);

    const getCartDetails = (cart: any) => {
        let currency = localeStore.selected.currency;
        let result = {
            type: CartTypes.Unknown,
            amount: 0,
            currency: currency
        };
        try {
            switch (cart.type) {
                case CartTypes.Samaritan: {
                    result.type = CartTypes.Samaritan;
                    if (cart.extensionProduct) {
                        result.amount += cart.extensionProduct.prices[currency]
                    }
                    break;
                }
                case CartTypes.GiftCard: {
                    result.type = CartTypes.GiftCard;
                    if (cart.extensionProduct) {
                        result.amount += cart.extensionProduct.prices[currency]
                    }
                    if (cart.cardProduct) {
                        result.amount += cart.cardProduct.prices[currency]
                    }
                    break;
                }
                default: {
                    result.type = CartTypes.Regular;
                    cart.forEach((cartItem: any) => {
                        result.amount += cartItem.product.prices[currency];
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }
        return result;
    }

    const getCookie = (name: string) => {
        if (import.meta.server) return null; // Safety check for Nuxt SSR
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();
        return null;
    };

    const reportToMeta = (eventName: string, params: any) => {
        if (typeof window !== 'undefined' && window.fbq) {
            const eventData: MetaEvent = {
                eventID: params.eventId,
            };

            if (config.public.metaTestCode) {
                eventData.test_event_code = config.public.metaTestCode;
            }
            const data = {
                value: params.totalAmount / 100,
                currency: params.currency,
                content_name: params.contentName,
                fbp: getCookie('_fbp') || null,
                fbc: getCookie('_fbc') || null
            };
            window.fbq('track', eventName, data, eventData);
        }
    };

    const startCheckout = async (payload: any, successUrl: string, cancelUrl: string) => {
        isProcessing.value = true;
        paymentError.value = null;
        const cartDetails = getCartDetails(payload.cart);
        const data = {
            eventId: uuidv4(),
            contentName: cartDetails.type,
            totalAmount: cartDetails.amount,
            currency: cartDetails.currency
        }
        reportToMeta('InitiateCheckout', data);
        payload.eventId = data.eventId;
        payload.fbp = getCookie('_fbp');
        payload.fbc = getCookie('_fbc');
        const fullBody = {
            ...payload,
            urls: {
                success: localePath(successUrl),
                cancel: localePath(cancelUrl)
            }
        }

        try {
            const response = await $fetch<{ sessionUrl: string }>(`${config.public.apiBase}/api/checkout`, {
                method: 'POST',
                body: fullBody
            });

            if (response.sessionUrl) {
                window.location.href = response.sessionUrl;
            }
            return response;
        } catch (err: any) {
            console.error("Checkout Error:", err);
            paymentError.value = err.message || "An unexpected error occurred.";
        } finally {
            isProcessing.value = false;
        }
    };

    return {
        startCheckout,
        reportToMeta,
        isProcessing,
        paymentError
    };
};